module.exports = __webpack_public_path__ + "static/media/dash.1ce97adc.png";